import { render } from "./CompetitorList.vue?vue&type=template&id=e0a46076"
import script from "./CompetitorList.vue?vue&type=script&lang=ts"
export * from "./CompetitorList.vue?vue&type=script&lang=ts"
script.render = render

export default script